package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebButton
import com.merkost.handpass.sharedweb.components.WebButtonSize
import com.merkost.handpass.sharedweb.components.WebButtonVariant

enum class AdminButtonVariant { Primary, Secondary, Destructive, Ghost, Ok }
enum class AdminButtonSize { SM, MD, LG }

@Composable
fun AdminButton(
    label: String,
    onClick: () -> Unit,
    variant: AdminButtonVariant = AdminButtonVariant.Primary,
    size: AdminButtonSize = AdminButtonSize.MD,
    enabled: Boolean = true,
    loading: Boolean = false,
    fillWidth: Boolean = false,
    leadingContent: (@Composable () -> Unit)? = null,
) {
    WebButton(
        label = label,
        onClick = onClick,
        variant = variant.toWeb(),
        size = size.toWeb(),
        enabled = enabled,
        loading = loading,
        fillWidth = fillWidth,
        leadingContent = leadingContent,
    )
}

private fun AdminButtonVariant.toWeb(): WebButtonVariant = when (this) {
    AdminButtonVariant.Primary -> WebButtonVariant.Primary
    AdminButtonVariant.Secondary -> WebButtonVariant.Secondary
    AdminButtonVariant.Destructive -> WebButtonVariant.Destructive
    AdminButtonVariant.Ghost -> WebButtonVariant.Ghost
    AdminButtonVariant.Ok -> WebButtonVariant.Ok
}

private fun AdminButtonSize.toWeb(): WebButtonSize = when (this) {
    AdminButtonSize.SM -> WebButtonSize.SM
    AdminButtonSize.MD -> WebButtonSize.MD
    AdminButtonSize.LG -> WebButtonSize.LG
}
